import React from 'react';
import {useOutletContext} from 'react-router-dom';
import {DictionaryItemsList} from './DictionaryItemsList';
import {DictionaryType} from '../types/DictionaryItem';

interface OutletContext {
  dictionaryType: DictionaryType;
}

const DictionaryItemsListWrapper: React.FC = () => {
  const { dictionaryType } = useOutletContext<OutletContext>();
  
  return <DictionaryItemsList dictionaryType={dictionaryType} />;
};

export default DictionaryItemsListWrapper;
